import { c as _c } from "react/compiler-runtime";
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import { PaymentStatusInterface } from 'shared/notifications/types/payment-status-interface';
import { useControlledSwr } from '../../hooks/use-controlled-swr';
import { isSioHost } from '@systemeio/util';
export function useSwrPaymentNotifications() {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  const {
    isCustomer,
    user
  } = useUser();
  let t1;
  if ($[1] !== isCustomer || $[2] !== user) {
    t1 = !!user && isCustomer && isSioHost(window.location.host);
    $[1] = isCustomer;
    $[2] = user;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return useControlledSwr("/api/dashboard/customer/payment/payment/notifications", fetcher, undefined, t1);
}